const initialState = {
	isMobile: null,
	size: {
		width: window.innerWidth,
		height: window.innerHeight
	},
	mobileBreakpoint: 1200,
	isMobileSize: false
}

const device = (state = initialState, action) => {
	switch(action.type) {
		case 'SET_DEVICE_TO_MOBILE':
			return {
				...state,
				isMobile: action.isMobile
			}

		case 'SET_DEVICE_SIZE':
			let isMobileSize = action.width <= state.mobileBreakpoint ? true : false;
			return {
				...state,
				isMobileSize: isMobileSize,
				size: {
					width: action.width,
					height: action.height
				}
			}
		default:
			return state
	}
}

export default device